module.exports = __webpack_public_path__ + "static/img/Business06.5aa86c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Business06.png
// module id = ZFbB
// module chunks = 2